module.exports = __webpack_public_path__ + "img/charging-hub-realized-private.d1c2b864.png";